var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import $ from 'jquery';
/**
 * Retrieves the most recent weather data from a station.
 * @param stationId - The ID of the station.
 * @returns The weather data.
 */
export function getWeather(stationId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield $.get(`/api/weather/${stationId}`).promise();
        }
        catch (_) {
            return null;
        }
    });
}
